import { useBack } from "../http";
import { AccountDTO } from "../types/AccountDTO";
import { LoginDTO } from "../types/LoginDTO";
import { PermissionsDTO } from "../types/PermissionsDTO";

export class LoginService {
	constructor() {}
	axiosInstance = useBack();

	async autentica(login: LoginDTO) {
		const url = '/login';
		try {
			const response = await this.axiosInstance.post<LoginDTO>(url, login);
			return { ...response };
		} catch (error) {
			console.log(`Erro ao realizar o login: `, error);
			return undefined;
		}
	}

	async getDataUser() {
		try {
			const response = await this.axiosInstance.get<AccountDTO>("/login/data");
			return { ...response };
		} catch (error) {
			console.log(`Erro ao buscar as informações do usuário: `, error);
			return undefined;
		}
	}

	async getPermissions() {
		try {
			const response = await this.axiosInstance.get<PermissionsDTO>("/login/me");
			return { ...response };
		} catch (error) {
			console.log(`Erro ao buscar as permissões do usuário: `, error);
			return undefined;
		}
	}
}